"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var styles = {
  "overlay-root": "modal-overlay-root-HYDcG",
  "overlay": "modal-overlay-1Ki3X",
  "title": "modal-title-2gcDL",
  "footer": "modal-footer-3rxbf",
  "content": "modal-content-3Y4Xs",
  "modal": "modal-modal-210sN",
  "close-button": "modal-close-button-1qkbz",
  "overlayRoot": "modal-overlay-root-HYDcG",
  "closeButton": "modal-close-button-1qkbz"
};

var ModalTitle = function ModalTitle(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'h1' : _ref$tag,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className", "tag"]);
  return /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({
    className: _utils.classNames.use(styles.title).join(className)
  }, restProps), children);
};

ModalTitle.displayName = "ModalTitle";
ModalTitle.displayName = 'ModalTitle';
var _default = ModalTitle;
exports["default"] = _default;